(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('SideNavController', SideNavController);

  /* ngInject */
  function SideNavController(sessionService) {
    const vm = this;

    vm.hasProduct = hasProduct;

    function hasProduct(productName) {
      const productRoles = sessionService.getProductRoles();

      // eslint-disable-next-line camelcase
      return productRoles.filter(productRole => productName == productRole.product_name).length > 0;
    }
  }
})();
